import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconSupport } from '@redteclab/icons'

import { Button } from 'base-ui'

import { DirectContactTelephoneDialog } from '../../direct-contact'
import { useOpenableControls } from '../../generic-hooks'
import { useOtherTopicsContactFullStoryTracking } from '../hooks/useOtherTopicsContactFullStoryTracking'

export const OtherTopicsCallUsCta: FC = () => {
  const modalControlsTelephoneDialog = useOpenableControls()
  useOtherTopicsContactFullStoryTracking()

  return (
    <>
      <Button
        className="w-full gap-1 rounded-m bg-light-brand-medium px-4 py-6"
        endIcon={<IconArrowRight className="fill-dark-brand" />}
        id="contact.email.info"
        onClick={() => {
          modalControlsTelephoneDialog.handleOpen()
        }}
        size="large"
        startIcon={<IconSupport className="fill-dark-brand" />}
        variant="text"
      >
        <span className="grow whitespace-normal text-start">
          <FormattedMessage id="help.centre.others.options.call.us" />
        </span>
      </Button>
      <DirectContactTelephoneDialog
        modalControls={modalControlsTelephoneDialog}
      />
    </>
  )
}
